import { useEffect } from 'react'

import {
  createVideoAnalysisFromError,
  createVideoAnalysisFromJob,
} from '../components/post-creator/mediaAttachments'

function mergeTranscriptionOutput(currentValue, outputPayload = {}) {
  return {
    ...currentValue,
    transcript: outputPayload?.transcript || currentValue.transcript,
    caption: outputPayload?.caption || currentValue.caption,
    captions: outputPayload?.caption ? [outputPayload.caption] : currentValue.captions,
    tags: Array.isArray(outputPayload?.tags) ? outputPayload.tags : currentValue.tags,
    betSummary: outputPayload?.summary && Object.keys(outputPayload.summary).length > 0
      ? outputPayload.summary
      : currentValue.betSummary,
  }
}

// Applies the composer's polled video-analysis (transcription) jobs: a
// completed job folds its transcript, caption, tags and bet summary into
// aiReview, and a completed, failed or errored poll settles the job's entry
// in transcriptionJobs. It requests nothing else; suggested bets run only
// from their card's button (useSuggestedBets, #870).
export function useTranscriptionJobPolling({
  pollingTranscriptionEntries,
  transcriptionJobQueries,
  setAiReview,
  setTranscriptionJobs,
}) {
  useEffect(() => {
    pollingTranscriptionEntries.forEach(([mediaId], index) => {
      const query = transcriptionJobQueries[index]
      const job = query?.data?.job

      if (job?.status === 'completed') {
        setAiReview((currentValue) => mergeTranscriptionOutput(currentValue, job.result || {}))
        setTranscriptionJobs((currentValue) => {
          const currentEntry = currentValue[mediaId]
          if (!currentEntry || (currentEntry.status !== 'polling' && currentEntry.status !== 'retrying')) return currentValue
          return {
            ...currentValue,
            [mediaId]: createVideoAnalysisFromJob(job, currentEntry),
          }
        })
        return
      }

      if (job?.status === 'failed') {
        setTranscriptionJobs((currentValue) => {
          const currentEntry = currentValue[mediaId]
          if (!currentEntry || (currentEntry.status !== 'polling' && currentEntry.status !== 'retrying')) return currentValue
          return {
            ...currentValue,
            [mediaId]: createVideoAnalysisFromJob(job, currentEntry),
          }
        })
        return
      }

      if (query?.isError) {
        setTranscriptionJobs((currentValue) => {
          const currentEntry = currentValue[mediaId]
          if (!currentEntry || (currentEntry.status !== 'polling' && currentEntry.status !== 'retrying')) return currentValue
          const timeoutError = query.error?.isTranscriptionTimeout
            ? { code: 'analysis_timeout', retryable: true }
            : query.error
          return {
            ...currentValue,
            [mediaId]: {
              ...currentEntry,
              ...createVideoAnalysisFromError(timeoutError),
            },
          }
        })
      }
    })
  }, [pollingTranscriptionEntries, setAiReview, setTranscriptionJobs, transcriptionJobQueries])
}
